<template>
    <div class="d-flex w-100 px-2">
        <div class="flex-grow-1">
            {{ supplierCodeValue }}
        </div>
        <div v-if="isPreferredSupplier"
             v-tooltip="'Preferred Supplier'"
             class="text-success">
            <i class="fa-solid fa-check-double"></i>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'AgGridCellRendererSupplierCode',
    computed: {
        supplierCodeValue() {
            return _.get(this.params, 'data.supplierCode.code')
        },

        supplierCodeStatus() {
            return _.get(this.params, 'data.supplierCode.status')
        },

        isPreferredSupplier() {
            return this.supplierCodeStatus === 'PREFERRED'
        }
    }
})
</script>

<style lang="scss" scoped>
</style>
